window.addEventListener('DOMContentLoaded', function () {
    if (window.Extend && window.Extend.buttons) {

        try {
            // Get params from URL
            const params = (new URL(document.location)).searchParams;

            // Check if leadToken or leadtoken is in the URL
            let leadToken = params.get('leadToken')
                ? params.get('leadToken')
                : params.get('leadtoken');

            if (leadToken) {
                Extend.aftermarketModal.open({
                    leadToken: leadToken,
                    onClose: function (plan, product, quantity) {
                        if (plan && product && product.id && product.name) {
                            // a user has selected a plan.  Add it to their cart.
                            const {planId , price, term} = plan
                            const extendSKU = planId === "A2-SGFIT-4y" ? "50385440145690" : "50385306616090"

                            // add to cart using fetch
                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                  'Content-Type': 'application/json',
                                  'Accept': 'application/json'
                                },
                                body: JSON.stringify({
                                  id: extendSKU,
                                  quantity: 1,
                                  properties: {
                                    "__leadToken": leadToken,
                                    "__extendPlanId": planId,
                                    "__coveredProductId": product.id,
                                    "__coveredProductName": product.name,
                                  }
                                })
                              })
                              .then(response => response.json())
                              .then(data => {
                                    const url = new URL(window.location.href);

                                    // Case-insensitive removal
                                    for (const key of url.searchParams.keys()) {
                                        if (key.toLowerCase() === 'leadtoken') {
                                            url.searchParams.delete(key);
                                        }
                                    }

                                    window.history.replaceState({}, document.title, url.toString());

                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 500);
                              })
                              .catch(error => {
                                console.error('Error adding to cart:', error);
                              });
                          }
                    }
                });
            }
        } catch (error) {
            console.error("EXTEND: " + error);
        }
    }
});
